export default "__VITE_ASSET__CktUJiZd__"